import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

import { Image } from 'components/core/Image';
import { H3, Paragraph } from 'components/core/Typography';

import { ClickToShowNumberButton } from 'components/contact/ClickToShowNumberButton';

import './PhoneCalloutLarge.scss';


// I know this is a duplicate pattern, I would argue
// the smaller Phone Callout be replace by this one
// and we standardize on it
export function PhoneCalloutLarge({
	headline,
	image,
	subheading,
	vertical,
	fetchPhoneNumber,
	OMIAppRentalCompleted,
	facilityPhone,
	unformattedFacilityPhone
}) {
	return (
		<div className={classnames(vertical ? 'vertical' : 'horizontal', 'phone-callout-large')}>
			{!!image &&
				<Image
					className="callout-image"					
					src={image}
				/>
			}
			<div className="callout-content">
				<H3 size="medium">
					{headline}
				</H3>
				<Paragraph color="black" last>
					{subheading}
				</Paragraph>
			</div>
			<div className="callout-phone-number">
				<ClickToShowNumberButton
					className="phone-number-button"
					outline
					dark
					size="standard"
					fetchPhoneNumber={fetchPhoneNumber}
					OMIAppRentalCompleted={OMIAppRentalCompleted}
					facilityPhone={facilityPhone}
					unformattedFacilityPhone={unformattedFacilityPhone}
				/>

			</div>
		</div>
	);
}

PhoneCalloutLarge.propTypes = {
	headline: PropTypes.string,
	image: PropTypes.string,
	subheading: PropTypes.string,
	vertical: PropTypes.bool,
	fetchPhoneNumber: PropTypes.func,
	OMIAppRentalCompleted: PropTypes.bool,
	facilityPhone: PropTypes.string,
	unformattedFacilityPhone: PropTypes.string
};

export default PhoneCalloutLarge;
